import { Option } from "../../../../../../../../constants/common";

export const Allergy: Option[] = [
  { value: "Edit", label: "Edit" },
  // { value: "Inactive", label: "Mark as Inactive" },
  { value: "ExportToNote", label: "Export to Note" },
  { value: "delete", label: "Delete" },
];

export const DiagnosisOptions: Option[] = [
  { value: "Edit", label: "Edit" },
  // { value: "ExportToNote", label: "Export to Note" },
  // { value: "Controlled", label: "Mark as Controlled" },
  // { value: "Resolved", label: "Mark as Resolved" },
  { value: "delete", label: "Delete" },
];

export const MedicationOptions: Option[] = [
  { value: "Edit", label: "Edit" },
  // { value: "Refill", label: "Refill" },
  // { value: "ChangeDose", label: "Change Dose" },
  // { value: "Discontinue", label: "Discontinue" },
  { value: "ExportToNote", label: "Export to Note" },
  // { value: "setTempMedication", label: "Set As Temp Med" },
  // { value: "Print", label: "Print Script" },
  { value: "delete", label: "Delete" },
];

export const VaccineOptions: Option[] = [
  { value: "Edit", label: "Edit" },
  { value: "ExportToNote", label: "Export to Note" },
  // { value: "Print", label: "Print Script" },
  // { value: "Refill", label: "Refill" },
  // { value: "ChangeDose", label: "Change Dose" },
  // { value: "setTempMedication", label: "Set As Temp Med" },
  // { value: "Discontinue", label: "Discontinue" },
  { value: "delete", label: "Delete" },
];


export const CareOptions: Option[] = [
  { value: "Edit", label: "Edit" },
  // note : we are not exporting care plan to note in visit note.
  // { value: "ExportToNote", label: "Export to Note" },
  { value: "Delete", label: "Delete" },
];

export const paginationForSideBar = {
  page: 0,
  pageSize: 2,
};
